import { PENDING_UPSERT_STATUSES } from '../../../utils';

const DISPLAYED_UPSERT_STATUSES = ['done', ...PENDING_UPSERT_STATUSES];

const getSupplementTotal = task =>
  (task.budgetDetails?.supplements || []).reduce(
    (total, supplement) => total + (supplement.additionalBudget || 0),
    0
  );

const applyToLines = (previousLines, upsertBudget, sign) => {
  if (!previousLines) {
    return null;
  }
  return previousLines.map(line => {
    const contribution = line.budgetKey ? upsertBudget[line.budgetKey] || 0 : 0;
    if (line.amount === null || line.amount === undefined) {
      return line;
    }
    return { ...line, amount: line.amount + sign * contribution };
  });
};

const getAppliedBudget = tasks =>
  tasks.reduce((appliedBudget, task) => {
    const taskBudget = task.withDataPlan?.budget;
    if (!taskBudget) {
      return appliedBudget;
    }
    return Object.keys(taskBudget).reduce((accBudget, key) => {
      if (typeof taskBudget[key] !== 'number') {
        return accBudget;
      }
      return { ...accBudget, [key]: (accBudget[key] || 0) + taskBudget[key] };
    }, appliedBudget);
  }, {});

const buildUpsertVersion = (task, index, previousVersion) => {
  const upsertBudget = task.withDataPlan?.budget || null;
  const supplement = upsertBudget
    ? upsertBudget.total || 0
    : getSupplementTotal(task);
  const totalHT = Math.round(previousVersion.totalHT + supplement);
  const hasUnknownBreakdown = !upsertBudget && supplement !== 0;

  return {
    type: 'upsert',
    key: task._id || task.id,
    index,
    requestedAt: task.createdAt || null,
    pushedAt: task.doneAt || null,
    isPushed: task.status === 'done',
    lines: hasUnknownBreakdown
      ? null
      : applyToLines(previousVersion.lines, upsertBudget || {}, 1),
    totalHT,
    delta: totalHT - previousVersion.totalHT
  };
};

const buildBudgetVersions = ({
  campaign,
  upsertTasks,
  initialLines,
  totalHT,
  initialPushedAt
}) => {
  const sortedUpserts = (upsertTasks || [])
    .filter(task => DISPLAYED_UPSERT_STATUSES.includes(task.status))
    .sort(
      (firstTask, secondTask) =>
        new Date(firstTask.createdAt) - new Date(secondTask.createdAt)
    );

  const appliedTasks = sortedUpserts.filter(task => task.status === 'done');
  const appliedBudget = getAppliedBudget(appliedTasks);

  const initialVersion = {
    type: 'initial',
    key: 'initial',
    requestedAt: campaign.createdAt || null,
    pushedAt: initialPushedAt || null,
    isPushed: true,
    lines: applyToLines(initialLines, appliedBudget, -1),
    totalHT: Math.round(totalHT - (appliedBudget.total || 0)),
    delta: null
  };

  return sortedUpserts.reduce(
    (versions, task) => {
      versions.push(
        buildUpsertVersion(task, versions.length, versions[versions.length - 1])
      );
      return versions;
    },
    [initialVersion]
  );
};

export { DISPLAYED_UPSERT_STATUSES };
export default buildBudgetVersions;
